module.exports = ".sd1 .col-md-1, .sd1 .col-md-2, .sd1 .col-md-4{\r\n    padding: 0px;\r\n }\r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/instruction-entry/instruction-entry.component.css
// module id = ./src/app/accountmaster/instruction-entry/instruction-entry.component.css
// module chunks = main